import { crudGetList } from 'react-admin';
import { useQuery, useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { deletePaymentService, getAllServices, getService } from '~/api/paymentServices';
import { PaymentService } from '~/types/paymentServices';
import { usePermissions } from 'react-admin';

export const useDeletePaymentService = (props?: any) => {
  const dispatch = useDispatch();

  return useMutation(deletePaymentService, {
    onSuccess() {
      dispatch(
        crudGetList('paymentServices', { page: 1, perPage: 10 }, { field: 'id', order: 'DESC' }, {})
      );
      props?.onSuccess && props.onSuccess();
    },
  });
};

export const useAllServicesQuery = (options?: {
  onSuccess?: (res: PaymentService[]) => void;
  enabled?: boolean;
}) => {
  const { permissions } = usePermissions();
  const hasPermissions = !!permissions?.includes('paymentService.list');

  const key = `paymentServices`;
  return useQuery<PaymentService[]>(key, () => getAllServices().then((res) => res.data), {
    ...options,
    enabled: hasPermissions && (options?.enabled ?? true),
  });
};

export const useGetServiceQuery = (
  serviceId: string,
  forPublicApi: boolean = false,
  options?: {
    onSuccess?: (res: PaymentService) => void;
    enabled?: boolean;
    staleTime?: number;
  }
) => {
  const { permissions } = usePermissions();
  const hasPermissions = !!permissions?.includes('paymentService.list');

  const key = `paymentServices/${serviceId}?forPublicApi=${forPublicApi}`;
  return useQuery<PaymentService>(
    key,
    () => getService(serviceId, forPublicApi).then((res) => res.data),
    {
      ...options,
      enabled: !!serviceId && hasPermissions && (options?.enabled ?? true),
    }
  );
};
